import React from 'react'
import PagesDrillDownTable from './PagesDrillDownTable'

class PagesDrillDownTableContainer extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    this.state = {}
  }

  componentDidMount () {
  }

  render () {
    return <PagesDrillDownTable {...this.props} {...this.state} />
  }
}

PagesDrillDownTableContainer.propTypes = {}

export default PagesDrillDownTableContainer



// WEBPACK FOOTER //
// ./src/components/PagesDrillDownTable/PagesDrillDownTableContainer.js